"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAnuncios = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var FetchAnuncios_1 = require("./FetchAnuncios");
require("assets/css/p.css");
var url_js_1 = require("../variables/url.js");
var fc_1 = require("react-icons/fc");
var espolAds_1 = require("../variables/espolAds");
var react_simple_tooltip_1 = require("react-simple-tooltip");
var textoMedidas = 'El tamaño mínimo 600x600 pixeles hasta un máximo de 1200x1200 pixeles, con una diferencia permitida entre ambas dimensiones de hasta 100 pixeles(Ejemplo: 850x950).';
var textoReiterativo = 'Con este Check indica si el anuncio estara presente en el mail masivo hasta el final de su vigencia.';
var textoPublicacion = 'Con este Check indica que en cuanto un revisor apruebe el anuncio sera publicado en la plataforma.';
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var infogestor = localBack + 'api/accounts/infogestor';
var categorias = localBack + 'api/Catalog/Categorias';
var audiencia = localBack + 'api/Catalog/Audiencia';
var anuncios = localBack + 'api/Catalog/Anuncios/';
var areas = localBack + 'api/Catalog/Area';
var areasGestor = localBack + 'api/Catalog/Area/areasgestorbyusername/';
var unidades = localBack + 'api/Catalog/Unidad';
var AddAnuncios = /** @class */ (function (_super) {
    __extends(AddAnuncios, _super);
    function AddAnuncios(props) {
        var _this = _super.call(this, props) || this;
        _this.imageHandler = function (e) {
            /*const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    this.setState({ file: reader.result })
                }
            }
            reader.readAsDataURL(e.target.files[0])*/
            /*console.log(e.target.files[0]);*/
            _this.setState({ file: e.target.files[0], fileName: e.target.files[0].name, alert4: true });
        };
        _this.ocultarElemento = function (tipo) {
            if (tipo == 'A') {
                document.getElementById("lugar").setAttribute("hidden", "hidden");
                document.getElementById("dtblock").setAttribute("hidden", "hidden");
                document.getElementById("txLugar").removeAttribute("required");
                document.getElementById("dtInicio").removeAttribute("required");
                document.getElementById("dtFin").removeAttribute("required");
            }
            else {
                document.getElementById("txLugar").setAttribute("required", "required");
                document.getElementById("dtInicio").setAttribute("required", "required");
                document.getElementById("dtFin").setAttribute("required", "required");
                document.getElementById("lugar").removeAttribute("hidden");
                document.getElementById("dtblock").removeAttribute("hidden");
            }
        };
        _this.onChangeTipo = function (tipo) {
            var dto = _this.state.dtoData;
            dto.bdTipo = tipo;
            _this.setState({ dtoData: dto, tipoComunicado: tipo });
        };
        _this.state = {
            title: "", loading: true, status: 0, statusText: "", editando: true, mostrar: true, infoGestor: [],
            categoriaList: [], audienciaList: [], audienciaCheck: [], dtoData: new FetchAnuncios_1.AnunciosData, file: null, fileName: "",
            alert: true, alert2: true, alert3: true, alert4: true, alert5: true, show: false, running: false, running2: false,
            message2: '', message3: '', message4: '', message5: '',
            visible: true, tipoComunicado: 'E', areas: [], unidades: [], unidad: 0, areasGestor: []
        };
        fetch(infogestor, {
            method: 'GET',
            headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ infoGestor: data, unidad: data['IdUnidad'] });
        });
        fetch(categorias)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ categoriaList: data });
        });
        fetch(areas)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ areas: data });
        });
        fetch(areasGestor + espolAds_1.getCookie('userEspol'))
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ areasGestor: data });
        });
        fetch(unidades)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ unidades: data });
        });
        fetch(audiencia, {
            method: 'GET',
            headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ audienciaList: data });
        });
        var dtoid = _this.props.match.params["id"];
        // This will set state for Edit 
        if (dtoid > 0) {
            fetch(anuncios + dtoid, {
                method: 'GET',
                headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
            })
                .then(function (response) {
                _this.setState({ status: response.status });
                return response.json();
            })
                .then(function (data) {
                _this.setState({
                    title: "Edit", loading: false, editando: true,
                    dtoData: data, fileName: data['txImagen'], audienciaCheck: data["audiencias"],
                    tipoComunicado: data['bdTipo']
                });
                console.log(data);
                console.log(data['txImagen']);
            });
        }
        else {
            var anun = new FetchAnuncios_1.AnunciosData;
            anun.idArea = _this.state.infoGestor['IdArea'];
            var uni = _this.state.infoGestor['IdUnidad'];
            _this.state = {
                title: "Create", loading: false, editando: false, mostrar: true, dtoData: anun, infoGestor: _this.state.infoGestor, categoriaList: [], audienciaList: [], audienciaCheck: [], file: null, fileName: "", status: 0, statusText: "",
                alert: true, alert2: true, alert3: true, alert4: true, alert5: true, show: false, running: false, running2: false, message2: '', message3: '', message4: '', message5: '',
                visible: true, tipoComunicado: 'E', areas: [], unidades: [], unidad: uni, areasGestor: []
            };
        }
        // This binding is necessary to make "this" work in the callback  
        _this.handleSave = _this.handleSave.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleCheckChange = _this.handleCheckChange.bind(_this);
        _this.handleImageChange = _this.handleImageChange.bind(_this);
        _this.imageHandler = _this.imageHandler.bind(_this);
        _this.automatico = _this.automatico.bind(_this);
        _this.oncodChangeCategoria = _this.oncodChangeCategoria.bind(_this);
        _this.handleCheck2 = _this.handleCheck2.bind(_this);
        _this.onDismiss = _this.onDismiss.bind(_this);
        _this.onChangeTipo = _this.onChangeTipo.bind(_this);
        _this.onChangeArea = _this.onChangeArea.bind(_this);
        return _this;
    }
    AddAnuncios.prototype.automatico = function (event) {
        var fecha = event.target.value;
        var dto = this.state.dtoData;
        dto["dtPublicacion"] = fecha;
        this.setState({ dtoData: dto });
        /*console.log(dto); */
    };
    AddAnuncios.prototype.handleInputChange = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var dto = this.state.dtoData;
        var tempDate = new Date();
        var year = tempDate.getFullYear();
        var mes = (tempDate.getMonth() + 1);
        var day = tempDate.getDate();
        if (mes >= 10 && day >= 10) {
            var date = year + '-' + mes + '-' + day;
        }
        else if (mes < 10 && day < 10) {
            var date = year + '-' + '0' + mes + '-' + '0' + day;
        }
        else if (mes < 10) {
            var date = year + '-' + '0' + mes + '-' + day;
        }
        else {
            var date = year + '-' + mes + '-' + '0' + day;
        }
        dto[name] = value;
        if (value && name == 'bdPublicarAutomatico') {
            dto["dtPublicacion"] = date;
            document.getElementById("dtPublicacion").setAttribute("readonly", "readonly");
        }
        else if (!value && name == 'bdPublicarAutomatico') {
            dto["dtPublicacion"] = "";
            document.getElementById("dtPublicacion").removeAttribute("readonly");
        }
        this.setState({ dtoData: dto });
    };
    AddAnuncios.prototype.handleCheckChange = function (evnt) {
        var dto = this.state.dtoData;
        var target = evnt.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var cd = this.state.audienciaCheck;
        if (value) {
            if (!cd.includes(name)) {
                cd.push(name);
            }
        }
        else {
            var n = cd.indexOf(name);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        this.setState({ audienciaCheck: cd });
        if (this.state.audienciaCheck.length > 0) {
            this.setState({ alert: true });
        }
        dto.audiencias = cd;
        this.setState({ dtoData: dto });
        /*console.log(this.state.dtoData);*/
    };
    AddAnuncios.prototype.handleCheck = function (id, check) {
        var dto = this.state.dtoData;
        var cd = this.state.dtoData.audiencias;
        if (check) {
            var n = cd.indexOf(id);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        else {
            if (!cd.includes(id)) {
                cd.push(id);
            }
        }
        this.setState({ audienciaCheck: cd });
        dto.audiencias = cd;
        this.setState({ dtoData: dto });
        /* console.log(this.state.dtoData);*/
    };
    AddAnuncios.prototype.handleCheck2 = function (event) {
        var dto = this.state.dtoData;
        var cd = dto.audiencias;
        var id = parseInt(event.target.value);
        if (this.state.dtoData.audiencias.includes(id)) {
            var n = cd.indexOf(id);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        else {
            if (!cd.includes(id)) {
                cd.push(id);
            }
        }
        dto.audiencias = cd;
        this.setState({ dtoData: dto, audienciaCheck: cd });
        /* console.log(this.state.dtoData);*/
    };
    AddAnuncios.prototype.handleImageChange = function (event) {
        var name = event.target.name;
        var dto = this.state.dtoData;
        dto[name] = URL.createObjectURL(event.target.files[0]);
        this.setState({ dtoData: dto, file: URL.createObjectURL(event.target.files[0]) });
        /* console.log(this.state);*/
    };
    AddAnuncios.prototype.oncodChangeCategoria = function (event) {
        var cod = event.target.value;
        var anuncio = this.state.dtoData;
        anuncio.idCategoria = cod;
        this.setState({ dtoData: anuncio });
        /*console.log(this.state.dtoData);*/
    };
    AddAnuncios.prototype.onChangeArea = function (event) {
        var cod = event.target.value;
        var anuncio = this.state.dtoData;
        anuncio.idArea = cod;
        var area = this.state.areas.filter(function (x) { return x.idArea == cod; });
        var uni = this.state.unidades.filter(function (x) { return x.idUnidad == area['idUnidad']; });
        this.setState({ dtoData: anuncio, unidad: uni['idUnidad'] });
    };
    AddAnuncios.prototype.onDismiss = function () {
        this.setState({ visible: false });
    };
    AddAnuncios.prototype.handleButton = function (estado) {
        //if (estado == 'B') {
        //    this.setState({ running2: true });
        //} else {
        //    this.setState({ running: true });
        //}
        var dto = this.state.dtoData;
        dto.bdEstado = estado;
        this.setState({ dtoData: dto });
    };
    AddAnuncios.prototype.end = function () {
        espolAds_1.expiro();
        this.props.history.push('/general/principal');
    };
    AddAnuncios.prototype.render = function () {
        var contents = this.state.status == 401 ?
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardHeader, null, "401 Unauthorized"),
                        React.createElement(reactstrap_1.CardBody, null, "Necesita un usuario tipo Creador para acceder."))))
            : this.state.status == 403 ? React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardHeader, null, "403 FORBIDDEN"),
                        React.createElement(reactstrap_1.CardBody, null, "No pertenece al tipo de usuario Creador."))))
                : this.state.status == 404 ? React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { md: 12 },
                        React.createElement(reactstrap_1.Card, null,
                            React.createElement(reactstrap_1.CardHeader, null, "404 NOT FOUND"),
                            React.createElement(reactstrap_1.CardBody, null, "No existe."))))
                    : this.state.loading
                        ? React.createElement("div", null,
                            React.createElement("h5", null,
                                React.createElement("em", null, "Loading...")),
                            React.createElement("div", { className: "loader" }))
                        : this.renderCreateForm(this.state.infoGestor, this.state.categoriaList, this.state.audienciaList, this.state.audienciaCheck);
        var edit = this.state.editando;
        if (edit) {
            return React.createElement("div", null,
                React.createElement("div", { id: "top" }),
                React.createElement(reactstrap_1.Card, null,
                    React.createElement(reactstrap_1.CardHeader, null,
                        React.createElement("h5", { className: "title" }, "EDITAR COMUNICADO")),
                    React.createElement(reactstrap_1.CardBody, null, contents)));
        }
        else {
            return React.createElement("div", null,
                React.createElement("div", { id: "top" }),
                React.createElement(reactstrap_1.Card, null,
                    React.createElement(reactstrap_1.CardHeader, null,
                        React.createElement("h5", { className: "title" }, "NUEVO COMUNICADO")),
                    React.createElement(reactstrap_1.CardBody, null, contents)));
        }
    };
    AddAnuncios.prototype.alertNotAudiencia = function () {
        /*alert("Las audiencias no pueden quedar vacias.");*/
        this.setState({ alert: false });
    };
    AddAnuncios.prototype.alertFechasInicioFin = function (texto) {
        /*alert("Las audiencias no pueden quedar vacias.");*/
        this.setState({ alert2: false, message2: texto });
    };
    AddAnuncios.prototype.alertVigencia = function (texto) {
        /*alert("Las audiencias no pueden quedar vacias.");*/
        this.setState({ alert3: false, message3: texto });
    };
    AddAnuncios.prototype.alertPublicacion = function (texto) {
        /*alert("Las audiencias no pueden quedar vacias.");*/
        this.setState({ alert5: false, message5: texto });
    };
    AddAnuncios.prototype.alertImagen = function () {
        /*alert("Las audiencias no pueden quedar vacias.");*/
        this.setState({ alert4: false });
    };
    AddAnuncios.prototype.alertResponse = function () {
        this.setState({ show: false });
        this.props.history.push("/creator/mis-comunicados");
    };
    AddAnuncios.prototype.changeFormat = function (fecha) {
        if (fecha !== null) {
            var resp = new Date(fecha.replace(/-/g, '\/'));
            return resp;
        }
        else {
            return null;
        }
    };
    AddAnuncios.prototype.bloqueoBt = function (estado) {
        if (estado == 'P') {
            this.setState({ running: true });
        }
        else {
            this.setState({ running2: true });
        }
    };
    AddAnuncios.prototype.handleSave = function (event) {
        var _this = this;
        var forma = new FormData(event.target);
        var dto = this.state.dtoData;
        this.bloqueoBt(dto.bdEstado);
        var problems = 0;
        forma.forEach(function (value, clave) {
            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                /*console.log(Boolean(value));*/
                dto[clave] = Boolean(value);
            }
            else if (value == '') {
                dto[clave] = null;
            }
            else {
                dto[clave] = value;
            }
        });
        forma.append('Imagen', this.state.file);
        var cd = this.state.audienciaCheck;
        for (var i = 0; i < cd.length; i++) {
            forma.append('Audiencias', cd[i]);
        }
        var data = JSON.stringify(dto);
        if (this.state.audienciaCheck.length === 0) {
            this.alertNotAudiencia();
            problems++;
        }
        else {
            this.setState({ alert: true });
        }
        if (this.state.dtoData.bdTipo == "E" && this.state.dtoData.bdEstado == "P") {
            var start = new Date(this.state.dtoData.dtInicio);
            var end = new Date(this.state.dtoData.dtFin);
            var ahora = new Date();
            ahora.setHours(0, 0, 0, 0);
            if (end < start) {
                this.alertFechasInicioFin('La fecha de inicio del evento es posterior a la fecha fin del evento, por favor corregir la fecha inicio del evento debe ser antes o igual a la fecha fin del evento.');
                problems++;
            }
            else if (start < ahora) {
                this.alertFechasInicioFin('La fecha de inicio del evento es anterior a la fecha actual, por favor corregir la fecha inicio del evento debe ser posterior a la fecha actual.');
                problems++;
            }
            else {
                this.setState({ alert2: true });
            }
        }
        var publi = this.changeFormat(this.state.dtoData.dtPublicacion);
        var vig = this.changeFormat(this.state.dtoData.dtVigencia);
        var ahora = new Date();
        ahora.setHours(0, 0, 0, 0);
        //console.log('publicacion', publi);
        //console.log('ahora', ahora);
        //console.log('vigencia', vig);
        if (vig < publi && this.state.dtoData.bdEstado == "P") {
            this.alertVigencia('La fecha de vigencia, es hasta que fecha estará disponible su publicación. Por favor la fecha de vigencia debe ser mayor o igual a la fecha de la publicación de su comunicado.');
            problems++;
        }
        else {
            this.setState({ alert3: true });
        }
        if (publi < ahora && this.state.dtoData.bdEstado == "P") {
            this.alertPublicacion('La fecha de publicación, es desde que fecha estará disponible su publicación. Por favor la fecha de publicación debe ser mayor o igual a la actual.');
            problems++;
        }
        else {
            this.setState({ alert5: true });
        }
        /*Creando*/
        if ((this.state.file === null) && this.state.dtoData.bdEstado === "P" && !this.state.editando) {
            this.alertImagen();
            problems++;
        }
        /*Editando*/
        if (this.state.editando && (this.state.fileName === '' || this.state.fileName === null)) {
            this.alertImagen();
            problems++;
        }
        if (problems === 0) {
            if (this.state.dtoData.idAnuncio > 0) {
                fetch(anuncios + this.state.dtoData.idAnuncio, {
                    method: 'PUT',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                    body: forma,
                })
                    .then(function (response) {
                    //response.json();
                    _this.setState({ status: response.status, statusText: response.statusText });
                    _this.props.history.push("/creator/mis-comunicados");
                    event.preventDefault();
                });
            }
            // POST request for Add employee.
            else {
                fetch(anuncios, {
                    method: 'POST',
                    headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
                    body: forma,
                }).then(function (response) {
                    response.json();
                    _this.setState({ status: response.status, statusText: response.statusText });
                    event.preventDefault();
                    _this.props.history.push("/creator/mis-comunicados");
                });
            }
        }
        if (problems) {
            this.setState({ running: false, running2: false });
        }
        problems = 0;
        /*console.log('status ',this.state.status);*/
        event.preventDefault();
    };
    // This will handle Cancel button click event.  
    AddAnuncios.prototype.handleCancel = function (e) {
        e.preventDefault();
        this.setState({ show: false });
        this.props.history.push("/creator/mis-comunicados");
    };
    // Returns the HTML Form to the render() method.  
    AddAnuncios.prototype.renderCreateForm = function (infoGestor, categoriaList, audienciaList, audienciaCheck) {
        var _this = this;
        var naud = audienciaList.length % 4;
        var rellaud = (4 - naud + 1) * 3;
        var colaud = "col-md-" + rellaud;
        return (React.createElement(React.Fragment, null,
            React.createElement("form", { className: "col-md-11", onSubmit: this.handleSave },
                React.createElement("div", { className: "form-group row col-md-12" },
                    React.createElement("input", { type: "hidden", name: "idAnuncio", value: this.state.dtoData.idAnuncio }),
                    React.createElement("input", { type: "hidden", name: "dtUltimoCambio", value: this.state.dtoData.dtUltimoCambio }),
                    React.createElement("input", { type: "hidden", name: "rowVersion", value: this.state.dtoData.rowVersion }),
                    React.createElement("input", { type: "hidden", name: "bdEstado", value: this.state.dtoData.bdEstado })),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Tipo"),
                    React.createElement("div", { className: "col-md-8" },
                        React.createElement("input", { type: "radio", id: "evento", name: "bdTipo", value: "E", onChange: function () { return _this.onChangeTipo("E"); }, required: true, checked: this.state.tipoComunicado === 'E' }),
                        " Evento \u00A0\u00A0",
                        React.createElement("input", { type: "radio", id: "anuncio", name: "bdTipo", value: "A", onChange: function () { return _this.onChangeTipo("A"); }, checked: this.state.tipoComunicado === 'A' }),
                        " Anuncio")),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Area*"),
                    React.createElement("div", { className: "col-md-8" },
                        React.createElement("select", { className: "  control-label form-control", id: "idArea", name: "idArea", onChange: this.onChangeArea, value: this.state.dtoData.idArea, required: true }, this.state.areas.filter(function (x) { return _this.state.areasGestor.includes(x.idArea); }).map(function (area) {
                            return React.createElement("option", { key: area.idArea, selected: area.idArea == _this.state.dtoData.idArea, value: area.idArea }, area.txNombreArea);
                        })))),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Categor\u00EDa*"),
                    React.createElement("div", { className: "col-md-4" },
                        React.createElement("select", { className: "  control-label form-control", id: "idCategoria", name: "idCategoria", onChange: this.oncodChangeCategoria, value: this.state.dtoData.idCategoria, required: true }, categoriaList.map(function (categoria) {
                            return React.createElement("option", { key: categoria.idCategoria, selected: categoria.idCategoria == _this.state.dtoData.idCategoria, value: categoria.idCategoria }, categoria.txNombreCategoria);
                        })))),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Audiencia *"),
                    React.createElement("div", { className: "col-md-10" },
                        React.createElement(reactstrap_1.Row, null,
                            audienciaList.map(function (audiencia) {
                                return React.createElement("div", { className: "checkboxes col-md-3" },
                                    React.createElement("label", null,
                                        React.createElement("input", { key: audiencia.idAudiencia, checked: _this.state.dtoData.audiencias.includes(audiencia.idAudiencia), name: audiencia.idAudiencia, type: "checkbox", onChange: _this.handleCheck2, value: audiencia.idAudiencia }),
                                        "\u00A0",
                                        audiencia.txNombre));
                            }),
                            React.createElement("div", { className: colaud })))),
                React.createElement("div", null,
                    React.createElement("input", { id: "numAud", type: "text", hidden: true })),
                React.createElement("div", null,
                    React.createElement("label", { hidden: this.state.alert, style: { color: 'red' } }, "*Las audiencias no pueden quedar vacias.")),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "T\u00EDtulo *"),
                    React.createElement("div", { className: "col-md-10" },
                        React.createElement("input", { className: "form-control", type: "text", id: "txTitulo", name: "txTitulo", defaultValue: this.state.dtoData.txTitulo, required: true }))),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Url/Enlace "),
                    React.createElement("div", { className: "col-md-10" },
                        React.createElement("input", { className: "form-control", type: "text", id: "txUrl", name: "txUrl", defaultValue: this.state.dtoData.txUrl }))),
                this.state.dtoData.bdTipo != "A" ?
                    React.createElement("div", { className: "form-group row", id: "lugar" },
                        React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Lugar *"),
                        React.createElement("div", { className: "col-md-4" },
                            React.createElement("input", { className: "form-control", type: "text", id: "txLugar", name: "txLugar", defaultValue: this.state.dtoData.txLugar, required: this.state.dtoData.bdTipo == "A" || this.state.dtoData.bdEstado == "B" ? false : true }))) : React.createElement(React.Fragment, null),
                this.state.dtoData.bdTipo != "A" ?
                    React.createElement("div", { className: "form-group row", id: "dtblock" },
                        React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Fecha inicio del evento *"),
                        React.createElement("div", { className: "col-md-4" },
                            React.createElement("input", { className: "form-control", type: "datetime-local", id: "dtInicio", name: "dtInicio", defaultValue: this.state.dtoData.dtInicio, required: this.state.dtoData.bdTipo == "A" || this.state.dtoData.bdEstado == "B" ? false : true })),
                        React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Fecha fin del evento *"),
                        React.createElement("div", { className: "col-md-4" },
                            React.createElement("input", { className: "form-control", type: "datetime-local", id: "dtFin", name: "dtFin", defaultValue: this.state.dtoData.dtFin, required: this.state.dtoData.bdTipo == "A" || this.state.dtoData.bdEstado == "B" ? false : true })))
                    : React.createElement(React.Fragment, null),
                React.createElement("div", null,
                    React.createElement("label", { hidden: this.state.alert2, style: { color: 'red' } },
                        "*",
                        this.state.message2)),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, "Fecha publicaci\u00F3n *"),
                    React.createElement("div", { className: "col-md-4" },
                        React.createElement("input", { className: "form-control", type: "date", id: "dtPublicacion", name: "dtPublicacion", defaultValue: this.state.dtoData.dtPublicacion == null ? null : this.state.dtoData.dtPublicacion.split("T")[0], onChange: this.automatico, required: this.state.dtoData.bdEstado == "B" ? false : true, value: this.state.dtoData.dtPublicacion == null ? null : this.state.dtoData.dtPublicacion.split("T")[0], readOnly: this.state.dtoData.bdPublicarAutomatico })),
                    React.createElement("label", { className: " control-label col-md-3 container", htmlFor: "Name" }, "Publicaci\u00F3n autom\u00E1tica*"),
                    React.createElement("div", { className: "col-md-3" },
                        React.createElement("input", { className: "form-control", name: "bdPublicarAutomatico", type: "checkbox", checked: this.state.dtoData.bdPublicarAutomatico, onChange: this.handleInputChange, value: "true" }))),
                React.createElement("div", null,
                    React.createElement("label", { hidden: this.state.alert5, style: { color: 'red' } },
                        "*",
                        this.state.message5)),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Vigencia *"),
                    React.createElement("div", { className: "col-md-4" },
                        React.createElement("input", { className: "form-control", type: "date", id: "dtVigencia", name: "dtVigencia", defaultValue: this.state.dtoData.dtVigencia == null ? null : this.state.dtoData.dtVigencia.split("T")[0], required: this.state.dtoData.bdEstado == "B" ? false : true })),
                    React.createElement("label", { hidden: true, className: " control-label col-md-3 container", htmlFor: "Name" },
                        React.createElement(react_simple_tooltip_1.default, { className: "mytooltip", placement: "right", content: textoReiterativo },
                            React.createElement(fc_1.FcInfo, null)),
                        " Comunicado Reiterativo*"),
                    React.createElement("div", { hidden: true, className: "col-md-3" },
                        React.createElement("input", { className: "form-control", name: "bdIsReiterativo", type: "checkbox", checked: this.state.dtoData.bdIsReiterativo, onChange: this.handleInputChange, value: "true" }))),
                React.createElement("div", null,
                    React.createElement("label", { hidden: this.state.alert3, style: { color: 'red' } },
                        "*",
                        this.state.message3)),
                React.createElement("div", { hidden: true, className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-12", htmlFor: "Name" }, "Fecha envio *"),
                    React.createElement("div", { className: "col-md-4" },
                        React.createElement("input", { className: "form-control", type: "text", name: "dtEnvio", defaultValue: this.state.dtoData.dtEnvio }))),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " \u00C1mbito *"),
                    React.createElement("div", { className: "col-md-6" }, this.state.dtoData.bdAmbito === "I" ?
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement("input", { type: "radio", id: "bdAmbitoI", name: "bdAmbito", value: "I", defaultChecked: true, required: true }),
                            " Interno \u00A0\u00A0",
                            React.createElement("input", { type: "radio", id: "bdAmbitoA", name: "bdAmbito", value: "A" }),
                            " Abierto")
                        : React.createElement("div", { className: "col-md-6" },
                            React.createElement("input", { type: "radio", id: "bdAmbitoI", name: "bdAmbito", value: "I", required: true }),
                            " Interno \u00A0\u00A0",
                            React.createElement("input", { type: "radio", id: "bdAmbitoA", name: "bdAmbito", value: "A", defaultChecked: true }),
                            " Abierto"))),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: " control-label col-md-2", htmlFor: "Name" }, " Descripci\u00F3n *"),
                    React.createElement("div", { className: "col-md-10" },
                        React.createElement("textarea", { className: "form-control", id: "txTexto", name: "txTexto", defaultValue: this.state.dtoData.txTexto, required: this.state.dtoData.bdEstado == "B" ? false : true }))),
                React.createElement(react_simple_tooltip_1.default, { className: "mytooltip", placement: "right", content: textoMedidas },
                    React.createElement(fc_1.FcInfo, null)),
                React.createElement("div", null,
                    React.createElement("label", { hidden: this.state.alert4, style: { color: 'red' } }, "*La imagen es requerida para solicitar aprobaci\u00F3n.")),
                React.createElement("div", { className: "form-group row" },
                    React.createElement("label", { className: "control-label col-md-2", htmlFor: "Name" }, " Arte de Comunicado* (1200 x 1200 px)"),
                    React.createElement("div", { className: "col-md-8" },
                        React.createElement("input", { className: "form-control btn-success", type: "text", value: this.state.fileName, readOnly: true, required: true })),
                    React.createElement("div", { className: "col-md-2 image-upload-D btn-success" },
                        "Adjuntar",
                        React.createElement("input", { type: "file", accept: "image/png, image/jpeg", className: "btn-success", onChange: this.imageHandler, name: "txImagen" }))),
                React.createElement("div", { className: "form-group row menu" },
                    React.createElement("label", { className: " control-label col-md-6", htmlFor: "Name" }),
                    React.createElement("div", { className: "col-md-6" },
                        React.createElement("button", { disabled: this.state.running || this.state.running2, onClick: function () { return (_this.handleButton("P")); }, type: "submit", className: "btn-info btn-round" }, this.state.running ? 'Solicitando...' : 'Solicitar Aprobación'),
                        "\u00A0\u00A0\u00A0",
                        React.createElement("button", { disabled: this.state.running || this.state.running2, onClick: function () { return (_this.handleButton("B")); }, type: "submit", className: "btn-success btn-round" }, this.state.running2 ? 'Guardando...' : 'Guardar'),
                        "\u00A0\u00A0\u00A0",
                        React.createElement("button", { className: "btn-warning btn-round", onClick: this.handleCancel }, "Cancelar"))))));
    };
    return AddAnuncios;
}(React.Component));
exports.AddAnuncios = AddAnuncios;
//# sourceMappingURL=AddAnuncios.js.map